export function clearAllCache() {
   const cache = window.caches;
   if (cache) {
      cache.keys().then(function (names) {
         for (const name of names) cache.delete(name);
      });
   }
}
